module.exports = "./img/3766d2305489db375ec24ec66192670a.jpg";